import React from 'react';

import { InfoField } from '@occc-app/design-system';
import { EarningMechanismMembershipEventFragment, Membership_Event_Type } from '@occc/graphql';

const membershipEventTypeMap: { [key in Membership_Event_Type]: string } = {
  [Membership_Event_Type.Birthday]: 'Birthday',
  [Membership_Event_Type.Active]: 'Active',
  [Membership_Event_Type.Created]: 'Created',
};
const formatEventType = ({
  membershipEventEventType,
}: {
  membershipEventEventType: Membership_Event_Type;
}): string => membershipEventTypeMap[membershipEventEventType];

interface IMembershipEventProps {
  earningMechanism: EarningMechanismMembershipEventFragment;
}

export const MembershipEvent: React.FC<IMembershipEventProps> = ({ earningMechanism }) => {
  return <InfoField label='Event Type' value={formatEventType(earningMechanism)} />;
};
